/**
 * The assistant proposal under review, if any. While it is set, every write the admin sends carries it as
 * X-Copilot-Proposal, so the server's activity log links the merchant's save to the change the assistant prepared.
 */
let activeProposalUid: string | null = null

export const setActiveProposal = (uid: string | null) => {
  activeProposalUid = uid
}

export const getActiveProposal = () => activeProposalUid
